module.exports = __webpack_public_path__ + "static/media/pied-piper-pp.9c350a9b.svg";